import {inject, Injectable} from '@angular/core';
import {SessionStorageService} from '../services';

const DCP_HIDE_HEADER_FLAG: string = 'dcp-hide-header-flag';

@Injectable({
  providedIn: 'root',
})
export class HideHeaderService {
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);

  updateHideHeader(hideHeader: boolean): void {
    if (hideHeader) {
      this.sessionStorageService.setItem(DCP_HIDE_HEADER_FLAG, true.toString());
    } else {
      this.sessionStorageService.removeItem(DCP_HIDE_HEADER_FLAG);
    }
  }

  getHideStatus(): boolean {
    const sessionStorageValue = this.sessionStorageService.getItem(DCP_HIDE_HEADER_FLAG);
    return sessionStorageValue?.toLowerCase() === 'true';
  }
}
